import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

const PaymentModal = ({ show, handleFunctionS, onClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const handleClose = () => {
    reset(); // reset form saat modal ditutup
    onClose();
  };

  const [rows, setRows] = useState([
    {
      name: null,
      type: "string",
      description: null,
      enum: [],
      required: false,
    },
  ]);

  const submitForm = (data) => {
    const datas = {
      name: data.paymentName.replace(/\s+/g, ""),
      description: data.paymentName,
      parameters: rows,
      active: "Y",
      exec_type: "api",
      endpoint: "http:://midtrans.com",
      method: "POST",
      headers: null,
      body_type: "json",
      body: null,
      credentials: data.credentials,
      response_filter: null,
      response_prompt: null,
      response_media_type: null,
      response_media_url: null,
    };
    handleFunctionS(datas);
    handleClose(); // tutup modal setelah submit
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      size="md"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add-Ons Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(submitForm)}>
          <Form.Group className="mb-3">
            <Form.Label>Payment Method</Form.Label>
            <Form.Select
              className="w-50"
              defaultValue="midtrans"
              {...register("paymentMethod", { required: true })}
            >
              <option value="midtrans">Midtrans</option>
            </Form.Select>
            {errors.payment_method && (
              <small className="text-danger">Payment Method is required.</small>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Payment Name</Form.Label>
            <Form.Control
              type="text"
              {...register("paymentName", { required: true })}
            />
            {errors.paymentName && (
              <small className="text-danger">Payment Name is required.</small>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Credentials</Form.Label>
            <Form.Control
              type="text"
              {...register("credentials", { required: true })}
            />
            {errors.credentials && (
              <small className="text-danger">Credentials is required.</small>
            )}
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="danger" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button type="submit" variant="success">
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentModal;
